import Vue from 'vue'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  configure,
} from 'vee-validate'
import {
  email,
  max,
  min,
  numeric,
  required,
  // eslint-disable-next-line camelcase
  required_if,
  between,
  integer,
} from 'vee-validate/dist/rules'
import i18n from '@/i18n'

extend('email', email)
extend('max', max)
extend('min', min)
extend('numeric', numeric)
extend('required', required)
extend('required_if', required_if)
extend('between', between)
extend('integer', integer)

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)

configure({
  // this will be used to generate messages.
  defaultMessage: (field, values) => {
    values._field_ = i18n.t(`fields.${field}`)
    return i18n.t(`validations.${values._rule_}`, values)
  },
})
